export default __webpack_public_path__ + "static/media/pbox.5294c26c.gif";